import { CustomDropdownContainer } from './CustomDropdownContainer';
import Dropdown from 'react-dropdown';
import React from 'react';

export const CustomDropdown = ({ label, options, onChange, value }) => (
    <CustomDropdownContainer label={label}>
        <Dropdown options={options} onChange={onChange} value={value} />
    </CustomDropdownContainer>
);
